import React, {createContext, useState, useContext, useEffect} from "react"
import {get_gallery_data} from "../../init/image_gallery"

const ImageGalleryContext = createContext([])

export function use_image_gallery() {
  const context = useContext(ImageGalleryContext)
  if (!context) {
    throw new Error(
      "use_image_gallery must be wrapped in a <ImageGalleryProvider />"
    )
  }
  return context
}

function ImageGalleryProvider({children, image_slugs}) {
  const [images, set_images] = useState([])

  useEffect(() => {
    get_gallery_data(image_slugs).then(set_images)
  }, [image_slugs])

  return (
    <ImageGalleryContext.Provider value={images}>
      {children}
    </ImageGalleryContext.Provider>
  )
}

export default ImageGalleryProvider
